import { render, staticRenderFns } from "./TaskDetailHistory.vue?vue&type=template&id=fc48deae&scoped=true&lang=pug&"
import script from "./TaskDetailHistory.vue?vue&type=script&lang=js&"
export * from "./TaskDetailHistory.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailHistory.vue?vue&type=style&index=0&id=fc48deae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc48deae",
  null
  
)

export default component.exports